export const OVERLINE = `Equipe especializada em`
export const HEADLINE = `Cirurgia do Aparelho Digestivo`
export const DESCRIPTION = `Seja atendido com atenção e dedicação por uma equipe de cirurgiões especialistas em tratar e prevenir doenças do seu aparelho digestivo.`
export const BUTTON_LABEL = `Marcar Consulta`
export const BUTTON_SECONDARY_LABEL = `Marcar Exame`
